import { render, staticRenderFns } from "./PortalReceiptStep.vue?vue&type=template&id=1741d26e"
import script from "./PortalReceiptStep.vue?vue&type=script&lang=js"
export * from "./PortalReceiptStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports